<template>
	<div class="m-intro">
		<h2>正风肃纪反腐 鼓励举报监督</h2>
		<h6>一、举报内容</h6>
		<p style="color:red;font-size:16px">支持受理<span style="font-weight:bold">【圆通内部员工违纪违法】</span>行为的举报, 主要包括：</p>
		<p>（一）行贿受贿索贿，利益输送；</p>
		<p>（二）泄漏公司秘密，倒卖客户个人信息；</p>
		<p>（三）违规参股、经营、兼职；</p>
		<p>（四）利用职权谋取私利；</p>
		<p>（五）侵占公司财物；</p>
		<p>（六）其他违反法律法规和公司制度的行为。</p>
		<p style="color:red;font-size:16px">非上述类别问题的反映、举报, <span style="font-weight:bold">例如：快件遗失、派送、理赔、破损、延误、催件等问题请拨打95554。</span></p>
		<h6>二、举报要求</h6>
		<p>（一）举报应当实事求是，<span style="font-weight:bold">举报电话将全程录音</span>，禁止恶意举报、诬告陷害、辱骂恐吓等，否则将依法追究法律责任；</p>
		<p>（二）举报时，<span style="font-weight:bold">应留下准确的联系方式</span>，以便工作人员与您取得联系；</p>
		<p>（三）举报内容应包括<span style="font-weight:bold">被举报人的姓名、单位、职务，事情发生的时间、地点、经过</span>等信息，如有证据资料请一并提交；</p>
		<p>（四）钉钉扫码举报，<span style="font-weight:bold">我们将获取您的个人信息，以便调查</span>。</p>
		<h6>三、举报奖励</h6>
		<p>对举报有功人员将予以“一案一奖”，最高奖励50万元，并严格保密。</p>
	</div>
</template>

<script>
	export default {
		name: "HelloWorld",
		props: {
			msg: String,
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	h3 {
		margin: 40px 0 0;
	}
	ul {
		list-style-type: none;
		padding: 0;
	}
	li {
		display: inline-block;
		margin: 0 10px;
	}
	a {
		color: #42b983;
	}
</style>
